import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInsights } from "../../constants";
import { PriceInsightsListItem } from "../../insights.types";

export const requestProductPriceInsight = async (
  id: string
): Promise<PriceInsightsListItem> => {
  return await instance.get(buildUrl(ApiRoutesInsights.PriceInsights, id));
};
